module.exports = __webpack_public_path__ + "assets/84526dbc3aaa139b4477c936442f38ff.mp3";